const d = 'M480-360 280-559h400L480-360Z';

export default d;
